// extracted by mini-css-extract-plugin
export default {"root":"IconFullscreen_root__vbAAC"};